export const routeLoaders = {
  overview: () => import('../components/ResumenDashboard'),
  support: () => import('../components/Dashboard'),
  report: () => import('../components/Report'),
  journey: () => import('../pages/JourneyExperience'),
  team: () => import('../components/UserAdmin'),
  serviceTickets: () => import('../components/ServiceTickets'),
  gestionClientes: () => import('../prodClientes/ProdClientesShell'),
  surveyForm: () => import('../components/SurveyForm'),
  surveyClientRating: () => import('../components/SurveyClientRating'),
  publicSurvey: () => import('../components/PublicSurvey'),
  changePassword: () => import('../components/ChangePasswordForm')
};

const prefetchedRoutes = new Set();

export const prefetchRouteByKey = (routeKey) => {
  if (!routeKey || prefetchedRoutes.has(routeKey)) return;
  const loader = routeLoaders[routeKey];
  if (!loader) return;
  prefetchedRoutes.add(routeKey);
  loader().catch(() => {
    prefetchedRoutes.delete(routeKey);
  });
};

export const prefetchRouteByPath = (path) => {
  switch (path) {
    case '/overview':
      prefetchRouteByKey('overview');
      break;
    case '/support':
      prefetchRouteByKey('support');
      break;
    case '/journey-experience':
      prefetchRouteByKey('journey');
      break;
    case '/team':
      prefetchRouteByKey('team');
      break;
    case '/report':
      prefetchRouteByKey('report');
      break;
    case '/service-tickets':
      prefetchRouteByKey('serviceTickets');
      break;
    case '/gestion-clientes/usuarios':
      prefetchRouteByKey('team');
      break;
    case '/gestion-clientes':
    case '/gestion-clientes/clientes':
    case '/gestion-clientes/reportes':
    case '/gestion-clientes/feriados':
      prefetchRouteByKey('gestionClientes');
      break;
    default:
      if (path && path.startsWith('/gestion-clientes')) {
        prefetchRouteByKey('gestionClientes');
      }
      break;
  }
};

